var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicOffUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 17V21.1667V17ZM11.8333 2C10.9493 2 10.1014 2.35119 9.47631 2.97631C8.85119 3.60143 8.5 4.44928 8.5 5.33333V11.1667C8.5 12.0507 8.85119 12.8986 9.47631 13.5237C10.1014 14.1488 10.9493 14.5 11.8333 14.5C12.7174 14.5 13.5652 14.1488 14.1904 13.5237C14.8155 12.8986 15.1667 12.0507 15.1667 11.1667V5.33333C15.1667 4.44928 14.8155 3.60143 14.1904 2.97631C13.5652 2.35119 12.7174 2 11.8333 2V2Z",
    fill: "#FF274D",
    stroke: "#FF274D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 8.66675V11.1667C17.6667 12.7138 17.0521 14.1976 15.9581 15.2915C14.8642 16.3855 13.3804 17.0001 11.8333 17.0001C10.2862 17.0001 8.80251 16.3855 7.70854 15.2915C6.61458 14.1976 6 12.7138 6 11.1667V8.66675",
    stroke: "#FF274D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.52554,
    y1: 0.601614,
    x2: 20.0173,
    y2: 19.7324,
    stroke: "#FF274D",
    strokeWidth: 1.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOffUser);
export default __webpack_public_path__ + "static/media/Mic-off-user.8c296294.svg";
export { ForwardRef as ReactComponent };